<template>
  <header>
    <b-navbar toggleable="lg"
      :type="$store.state.Session.test ?'dark' :'light'"
      :variant="$store.state.Session.test ?'dark' :'light'"
      fixed="top" class="top-nav">
      <b-navbar-brand class="p-0">
        <div class="version">
          v{{version}}
          <span v-if="$store.state.Session.test" class="test">TEST MODE</span>
        </div>
        <b-img src="./img/banner.png" />
      </b-navbar-brand>

      <b-navbar-toggle target="navbar-toggle-collapse">
      </b-navbar-toggle>

      <b-collapse id="navbar-toggle-collapse" is-nav v-model="showCollapse">
        <b-navbar-nav class="mr-auto mb-auto">
          <b-nav-item href="#">
            <a @click="subNav = 'ResultNav'">
              <font-awesome-icon icon="file-alt" class="icon" />更新結果
            </a>
          </b-nav-item>
          <b-nav-item v-if="$store.state.Session.logined" href="#">
            <a @click="subNav = 'ActionNav'">
              <font-awesome-icon icon="user-alt" class="icon" />行動宣言
            </a>
          </b-nav-item>
          <b-nav-item v-if="$store.state.Session.logined" href="#">
            <a @click="subNav = 'SettingNav'">
              <font-awesome-icon icon="file-alt" class="icon" />プロフィール
            </a>
          </b-nav-item>
          <b-nav-item @click="showCollapse = false" href="#">
            <router-link to="/tv">
              <font-awesome-icon icon="tv" class="icon" />TV
            </router-link>
          </b-nav-item>
          <b-nav-item v-if="$store.state.Session.admin"
            @click="showCollapse = false" href="#">
            <a @click="subNav = 'AdminNav'">
              <font-awesome-icon icon="user-cog" class="icon" />管理
            </a>
          </b-nav-item>
          <b-nav-item href="#">
            <a @click="subNav = 'HelpNav'">
              <font-awesome-icon icon="question" class="icon" />ルールブック
            </a>
          </b-nav-item>
          <b-nav-item v-if="$store.state.Session.logined"  
            href="#" class="account-nav" >
            <a @click="subNav = 'AccountNav'">
              <b-avatar class="mr-0" size="1.25rem" :src="$store.getters.nowAccount.icon" />
              {{ $store.getters.nowAccount.nickname }}
            </a>
          </b-nav-item>
          <b-nav-item v-else 
            @click="showCollapse = false" href="#">
            <router-link to="/title">
              <font-awesome-icon icon="sign-in-alt" class="icon" />ログイン
            </router-link>
          </b-nav-item>
        </b-navbar-nav>
        <template v-if="subNav !== null">
          <component class="mr-auto mb-auto" :is="subNav" 
            @click="showCollapse = false"
            @click::logout="subNav = null" />
        </template>
      </b-collapse>

    </b-navbar>
  </header>
</template>

<script>
import ActionNav from '@/components/ActionNav'
import ResultNav from '@/components/ResultNav'
import SettingNav from '@/components/SettingNav'
import HelpNav from '@/components/HelpNav'
import AccountNav from '@/components/AccountNav'
import AdminNav from '@/components/AdminNav'
import { version } from '../../package'
export default {
  name: 'Header',
  components: {
    ResultNav,
    ActionNav,
    SettingNav,
    HelpNav,
    AccountNav,
    AdminNav
  },
  computed: {
    version () { return version }
  },
  data () {
    return {
      showHeader: true,
      subNav: null,
      showCollapse: false,
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
// .icon{
//   color: #533;
// }
header{
  margin: 0 auto 0 0;
  z-index: 400;
}
.account-nav {
  border: 1px solid #CCC;
  border-radius: 20px;
  // box-sizing: border-box;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;

  a {
    display: inline-block;
    padding-top: 0;
    padding-bottom: 0;
    vertical-align: middle;
  }
}
.version {
  font-size: 12px;
}
.test{
  animation: Flash1 2s infinite;
}
/* アニメーション */
@keyframes Flash1{
  50%{
    opacity: 0;
  }
}
@media screen {
  .top-nav{
    min-height: 75px;
    // width: 100vw;
  }
  #navbar-toggle-collapse{
    display: flex;
    flex-direction: row;
  }
}
@media (min-width: 960px) {
  #navbar-toggle-collapse{
    display: flex;
    flex-direction: column;
  }
}
</style>
